module.exports = __webpack_public_path__ + "img/noRencai.b241fa1b.png";